import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { igrejaService, type DadosIgrejaEditaveis } from "@/core/services/igrejaService";

const QUERY_KEY_IGREJA = ["igreja"];

/** Dados administrativos da igreja (tela /admin/igreja). */
export function useIgreja() {
  return useQuery({ queryKey: QUERY_KEY_IGREJA, queryFn: igrejaService.buscar });
}

export function useAtualizarIgreja() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, dados }: { id: string; dados: DadosIgrejaEditaveis }) =>
      igrejaService.atualizar(id, dados),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_IGREJA }),
  });
}
